<script>
import utils from '@/utils/common';
import BaseDatepicker from './BaseDatepicker.vue';

export default {
  name: 'BaseDate',
  components: { BaseDatepicker },
  props: {
    date: Date,
    editable: Boolean,
    gray: Boolean,
  },
  computed: {
    valueStr() { return utils.convertDateToString(this.date, 'short', true, false); },
    valueClass() {
      const now = new Date();
      if (this.gray) {
        return 'gray';
      }

      if (this.date < now) {
        return 'outdated';
      }

      if (this.date - now < 3 * 60 * 60 * 1000) {
        return 'burning';
      }

      if (this.date - now < 24 * 60 * 60 * 1000) {
        return 'hot';
      }

      return '';
    },
  },
  methods: {
    openCalendar() {
      if (!this.editable) return;
      this.$refs.taskDatePicker.open();
    },
  },
};
</script>

<template lang="pug">
.date(:class="{ editable }")
  .datetime(v-if="date" :class="valueClass" @click="openCalendar") {{ valueStr }}
  .datetime(v-else @click="openCalendar") Без<br>срока
  BaseDatepicker.datepicker(
    v-if="editable"
    type="datetime",
    @input="$emit('change', $event)"
    :value="date"
    hidden
    ref="taskDatePicker"
  )
</template>

<style scoped lang="scss">
.date {
  &.editable .datetime {
    cursor: pointer;
  }

  &.gray {
    color: #c5c5c5;
  }

  .datetime {
    text-align: start;
    font-size: 12px;
    line-height: 15px;
    justify-self: start;
    letter-spacing: 0.05em;
    color: var(--color-middle-gray);

    &.outdated {
      color: #EA4335;
    }

    &.burning {
      color: #FF8D4C;
    }

    &.hot {
      color: #F9D208;
    }
  }
}

.datepicker {
  font-size: 0;
}
</style>
